import React from 'react';
import { useTranslation } from 'react-i18next';
import { Briefcase } from 'lucide-react';
import './Timeline.css';

import talan from './images/talan.png';
import visioAd from './images/visioAd.png';
import proxym from './images/proxym.png';

// Wording (role, bullet points) lives in i18n under `experience.data.<key>`.
const experiences = [
    { key: 'talan', company: 'Talan Consulting Tunisie', start: '2026-02', end: '2026-06', logo: talan, wide: true },
    { key: 'visioad', company: 'VisioAd', start: '2025-08', end: '2025-08', logo: visioAd },
    { key: 'proxym', company: 'Proxym', start: '2025-07', end: '2025-07', logo: proxym },
    { key: 'tcs', company: 'Tunisie Computer Services', start: '2024-07', end: '2024-08', badge: 'TCS' },
    { key: 'freelance', company: null, start: '2024-03', end: null, icon: Briefcase },
];

const BULLETS_SHOWN = 2;

const CompanyLogo = ({ exp }) => {
    if (exp.logo) {
        return (
            <span className={`timeline-logo ${exp.wide ? 'timeline-logo--wide' : ''}`}>
                <img src={exp.logo} alt={exp.company} />
            </span>
        );
    }
    if (exp.badge) {
        return (
            <span className="timeline-logo">
                <span className="logo-badge">{exp.badge}</span>
            </span>
        );
    }
    const Icon = exp.icon;
    return (
        <span className="timeline-logo timeline-logo--icon">
            <Icon size={24} />
        </span>
    );
};

const ExperienceSection = () => {
    const { t, i18n } = useTranslation();
    const month = (ym) => new Date(`${ym}-01`).toLocaleDateString(i18n.language, { month: 'short', year: 'numeric' });

    return (
        <div className="timeline-column" id="Experience">
            <div className="section-header">
                <span className="eyebrow">{t('experience.eyebrow')}</span>
                <h2 className="section-title timeline-heading">{t('experience.title')}</h2>
            </div>

            <ol className="timeline timeline--rail">
                {experiences.map(exp => {
                    const data = `experience.data.${exp.key}`;
                    const bullets = t(`${data}.description`, { returnObjects: true }).slice(0, BULLETS_SHOWN);
                    return (
                        <li key={exp.key} className="timeline-item reveal">
                            <span className="timeline-rail" aria-hidden="true">
                                <span className="timeline-dot" />
                                <span className="timeline-line" />
                            </span>
                            <CompanyLogo exp={exp} />
                            <div className="timeline-content">
                                <div className="timeline-row">
                                    <h3 className="timeline-title">{t(`${data}.role`)}</h3>
                                    <span className="timeline-date">
                                        {month(exp.start)} – {exp.end ? month(exp.end) : t('projects.modal.present')}
                                    </span>
                                </div>
                                <p className="timeline-org">{exp.company || t('experience.self_employed')}</p>
                                <ul className="timeline-bullets">
                                    {bullets.map(b => <li key={b}>{b}</li>)}
                                </ul>
                            </div>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default ExperienceSection;
